module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DREAMS and VISIONS")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-02-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter5#b_31",
      "id": "a_31"
    }
  }, [_c('i', [_vm._v("Preface: Jesus and Muslims "), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-03-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter6#b_32",
      "id": "a_32"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART I")]), _vm._v(": E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GYPT")]), _vm._v("—H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSANNA TO THE")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ING OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RABS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter7#b_1",
      "id": "a_1"
    }
  }, [_vm._v("1. Friday at the Khan")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter8#b_2",
      "id": "a_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Imam and the Gun"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-05-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9#b_33",
      "id": "a_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART II")]), _vm._v(": S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUDI")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RABIA")]), _vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORBIDDEN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter10#b_3",
      "id": "a_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Infidel Gathering")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-06-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11#b_4",
      "id": "a_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. “Can I Worship Jesus in the Bathroom?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter12#b_5",
      "id": "a_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Martyr’s Final Poem")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13#b_6",
      "id": "a_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Bible Study in Mecca "), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-07-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter14#b_34",
      "id": "a_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART III")]), _vm._v(": I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAN")]), _vm._v("—W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HY")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HMADINEJAD")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN’T")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEEP AT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15#b_7",
      "id": "a_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. One Tough Burka.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-08-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter16#b_8",
      "id": "a_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Nukes, Imams, and the Underground Sheikh"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-09-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17#b_35",
      "id": "a_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART IV")]), _vm._v(": J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORDAN")]), _vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OP")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONORS IN")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONOR")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter18#b_9",
      "id": "a_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Clinically Impressed")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19#b_10",
      "id": "a_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Twice Converted"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter20#b_36",
      "id": "a_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intermission: The Great Awakening for Muslims"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter21#b_37",
      "id": "a_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART V")]), _vm._v(": S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YRIA")]), _vm._v("—S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PIES IN THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-02-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter22#b_11",
      "id": "a_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Secret Police’s Best Customer, Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-03-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter23#b_12",
      "id": "a_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Secret Police’s Best Customer, Part 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-04-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter24#b_13",
      "id": "a_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. “Your Killers Are on the Way!” "), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-05-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter25#b_38",
      "id": "a_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART VI")]), _vm._v(": I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAQ")]), _vm._v("—I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N THE ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGINNING")]), _vm._v(", G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REATED")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAQ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-06-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter26#b_14",
      "id": "a_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Swords of Baghdad, Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-07-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter26a#b_15",
      "id": "a_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Swords of Baghdad, Part 2"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-08-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter27#b_39",
      "id": "a_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART VII")]), _vm._v(": I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SRAEL")]), _vm._v(", G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AZA")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EST")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANK")]), _vm._v("—W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALLS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TILL")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OME")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-09-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter28#b_16",
      "id": "a_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Will the Real Jesus Please Stand Up?")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-10-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter29#b_17",
      "id": "a_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. “I Hate the Jews!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-11-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter29a#b_18",
      "id": "a_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Hummus with Hamas")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-12-11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter30#b_19",
      "id": "a_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. West Bank Story "), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-13-12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter31#b_40",
      "id": "a_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART VIII")]), _vm._v(": A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FGHANISTAN")]), _vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATES OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELL")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON’T")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REVAIL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-14-13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter32#b_20",
      "id": "a_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Man of Peace in “Boom!” Town")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-15-14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter33#b_21",
      "id": "a_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. “Why Are You in Our Country?”"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-16-15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter34#b_45",
      "id": "a_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART IX")]), _vm._v(": A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v("—L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVING")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USLIMS TO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRIST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-17-16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter35#b_22",
      "id": "a_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. A Veiled Threat")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-18-17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter36#b_23",
      "id": "a_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Muslim Boy in Bible Town")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-19-18"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter37#b_24",
      "id": "a_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Extreme Discipleship "), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-20-19"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter38#b_25",
      "id": "a_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 1: A Brief History of Visits from Jesus ")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-21-20"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter39#b_26",
      "id": "a_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 2: Real or Fake? A Biblical Test for Dreams and Visions")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter40#b_27",
      "id": "a_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 3: The Global Shift—Christianity Soars Ahead of Islam"), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter41#b_28",
      "id": "a_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 4: Fourteen Centuries of Outreach to Muslims"), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-03-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter42#b_29",
      "id": "a_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes"), _c('br'), _c('br')])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-04-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter42a#b_30",
      "id": "a_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 66
// module chunks = 0